import React from 'react';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import * as PropTypes from 'prop-types';

import DialogButton from '$app-web/modules/rdash/components/dialog-button';
import LoadingDots from '$app-web/modules/rdash/components/loading-dots';

import useStyles from './styles';

const LoadingButton = (props) => {
    const { className, buttonComponent: Button, loading, loadingTitle, title, ...restProps } = props;

    const classes = useStyles(props);

    const titleElement = (
        <>
            {loading ? (
                <motion.span
                    animate={{ opacity: [1, 0.75, 0.75, 1] }}
                    transition={{
                        times: [0, 0.5, 0.8, 1],
                        loop: Infinity,
                        duration: 0.5,
                        repeatDelay: 1,
                    }}
                    className={clsx(classes.buttonTitle)}
                >
                    {loadingTitle}
                </motion.span>
            ) : (
                <span className={clsx(classes.buttonTitle, { [classes.buttonTitleLoading]: loading })}>{title}</span>
            )}
            {loading && <LoadingDots />}
        </>
    );
    // it's better to unify `title` prop across the project, somewhere it's `title` or `children`
    return <Button className={clsx(classes.root, className)} title={titleElement} {...restProps} />;
};

LoadingButton.defaultProps = {
    className: undefined,
    loading: false,
    loadingTitle: undefined,
    buttonComponent: DialogButton,
};

LoadingButton.propTypes = {
    className: PropTypes.string,
    loading: PropTypes.bool,
    loadingTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    buttonComponent: PropTypes.elementType,
};

export default LoadingButton;
